import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-495e2ae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","width":"100%"} }
const _hoisted_2 = ["id", "placeholder"]
const _hoisted_3 = {
  key: 0,
  style: {"position":"absolute","left":"275px","top":"-3px","color":"red"}
}
const _hoisted_4 = { class: "tw-mb-[20px]" }
const _hoisted_5 = {
  key: 0,
  class: "tw-flex tw-gap-[20px] tw-flex-col"
}
const _hoisted_6 = {
  key: 1,
  class: "tw-flex tw-leading-[100%] tw-justify-between tw-gap-[20px] tw-bg-[#ffffff] tw-rounded-md tw-mt-5"
}
const _hoisted_7 = { class: "tw-flex tw-flex-col" }
const _hoisted_8 = { class: "tw-text-[14px] tw-font-poppins tw-text-[#231F20] tw-leading-[100%] tw-font-medium tw-mr-[7px] tw-mb-[4px]" }
const _hoisted_9 = { class: "tw-text-[12px] tw-font-poppins tw-text-[#878787] tw-leading-[100%] tw-font-normal tw-mr-[7px]" }
const _hoisted_10 = { class: "tw-flex tw-flex-end tw-items-center tw-bg-[#FFFFFF]" }

import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { ref, computed, reactive, watch } from "vue";
import WizardDetailWrapper from "./wizardDetailWrapper.vue";
import { getComponentUiText, isUrlFacingWeb } from "@/utils/utilities";
import store from "@/store";
import { generateWebServiceQuestionData } from "@/services/wizard";
import {
  statusPage,
  WIZARD_STATE_NAME,
  WIZARD_STATE_QUESTION_TYPE_ID,
  idWizardPage as idPage,
  WIZARD_STATE_PAGE,
} from "@/utils/constants";
import { DROPDOWN_TYPE } from "@/utils/constants";
import WizardMultiLevelMultiSelectQuestion from "./wizardMultiLevelMultiSelectQuestion.vue";
import WizardInputQuestion from "./wizardInputQuestion.vue";
import WizardRadioQuestion from "./wizardRadioQuestion.vue";
import ToggleSwitch from "@/components/common/toggleSwitch.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'listWebFacing',
  props: {
  data: {
    type: Object,
    required: true,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
},
  emits: [
  "changeDataWebFacing",
  "update:toggleValue",
  "update:value:store",
],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;

const isMoreDetails = ref(false);
const isToggle = ref(false);
const currentOrg = computed(() => store.state.Org.currentOrg);

const item = ref(props.data.item);
watch(
  () => props.data.item,
  (newValue) => {
    item.value = props.data.item;
  },
  { immediate: true },
);
const mesageError = ref(false);
const bodyAPIError = computed(() => {
  if (
    !item.value.id &&
    props.statusInPage.dataError.length > 0 &&
    item.value.isCallAPI
  ) {
    return true;
  }
  return (
    item.value.id &&
    props.statusInPage.dataError.find(
      (i) =>
        i.id === item.value.id &&
        (!i.serviceTypeId || i.serviceTypeId === item.value.serviceTypeId),
    )
  );
});

const statusInPageClone = ref(bodyAPIError);

const checkYesNo = (value) => {
  !item.value.id && (item.value.isCallAPI = false);
  item.value.isStatus = value;
  mesageError.value = false;
  if (!item.value.id) {
    item.value.typeId = "";
  }

  updateStore(item);
};
const updateValue = (value, data) => {
  updateStore(item);
};
const isUrlWebServiceValidation = (val) => {
  return isUrlFacingWeb(val) ? true : false;
};
const rules = computed(() => ({
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  ...(item.value.isStatus === 1 && {
    url: {
      required: helpers.withMessage(
        () => getComponentUiText("app-setting-org-detail-required-fields-1"),
        required,
      ),
      isUrlWebService: helpers.withMessage(
        () =>
          getComponentUiText("app-common-form-value-url-web-service-error-1"),
        isUrlWebServiceValidation,
      ),
    },
  }),
  ...(item.value.isStatus === 0 && {
    typeId: {
      required: helpers.withMessage(
        () => getComponentUiText("app-common-form-value-required-error-1"),
        required,
      ),
    },
  }),
}));
const webServiceData = [
  {
    questionTypeId: WIZARD_STATE_QUESTION_TYPE_ID.WEBSERVICE_WEB,
    title: "Website",
    selected: false,
    isToggle: false,
    childData: [],
  },
  {
    questionTypeId: WIZARD_STATE_QUESTION_TYPE_ID.WEBSERVICE_WEB_NAT,
    title: "Applications",
    selected: false,
    isToggle: false,
    childData: [],
  },
];

const questionSectionWebserviceValue = computed(() =>
  store.getters["SetupWizard/getQuestionsBySection"](
    WIZARD_STATE_NAME.WEBSERVICES,
    currentOrg.value.id || null,
  ),
);
let typeIdSelectedDropdown = "";

const dropdownDataValue = computed(() => {
  let result = [];
  const data = generateWebServiceQuestionData(
    webServiceData,
    questionSectionWebserviceValue.value,
  );

  result = data?.map((item) => {
    return {
      ...item,
      childData: item.childData.map((child) => ({
        ...child,
        title: child.name,
        selected: child.id === typeIdSelectedDropdown,
        questionTypeId: item.questionTypeId,
      })),
    };
  });
  return result;
});

const v$ = useVuelidate(rules, item as any);
const saveChanges = async () => {
  // false is errorr
  await v$.value.$validate();
  let isValid = !v$.value.$errors || v$.value.$errors.length === 0;
  if (item.value.isStatus === "") {
    mesageError.value = true;
    isValid = false;
  } else if (item.value.isStatus === 1 || item.value.isStatus === 0) {
    mesageError.value = false;
  }
  if (!isValid) {
    item.value.showAccordion = true;
  }
  return { isValid };
};
__expose({
  saveChanges,
});

const updateStore = (item) => {
  store.commit("SetupWizard/SET_IS_SELECTED_PAGE_WIZARD", {
    namePage: WIZARD_STATE_PAGE.WEBSERVICES,
    currentOrg: currentOrg.value.id,
    isSelected: true,
    isSelectedPage: "isSelectedWebFacing",
  });
};

const changeMoreDetail = (value: any) => {
  emits("update:toggleValue", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WizardDetailWrapper, {
      class: _normalizeClass(['tw-mb-[25px]']),
      title: item.value.title,
      data: __props.data,
      validation: _unref(v$).name,
      "show-accordion": item.value.showAccordion,
      "page-active": _unref(idPage).webFacingAppPage,
      "is-facing-web": true,
      "is-api-error": statusInPageClone.value,
      "onUpdate:accordion": _cache[7] || (_cache[7] = ($event: any) => (item.value.showAccordion = !item.value.showAccordion)),
      onInput: _cache[8] || (_cache[8] = ($event: any) => (updateStore(item.value)))
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            id: `input-webfacing-${__props.data.index}`,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.name) = $event)),
            class: "enter__name",
            placeholder: 
              _unref(getComponentUiText)(
                'app-menu-submenu-home-setup-wizard-web-facing-app-placeholder-input-1',
              )
            ,
            style: {"border":"unset","background-color":"unset"},
            onInput: _cache[1] || (_cache[1] = 
              () => {
                !item.value.id && (item.value.isCallAPI = false);
                statusInPageClone.value &&
                  statusInPageClone.value.name &&
                  delete statusInPageClone.value.name;
                statusInPageClone.value &&
                  (delete statusInPageClone.value.isDelete,
                  delete statusInPageClone.value.serviceTypeId);
                if (
                  statusInPageClone.value &&
                  Object.keys(statusInPageClone.value).length === 1 &&
                  statusInPageClone.value.hasOwnProperty('id')
                ) {
                  delete statusInPageClone.value.id;
                }
              }
            ),
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, null, 40, _hoisted_2), [
            [_vModelText, item.value.name]
          ]),
          (!item.value.name)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(WizardRadioQuestion, {
          class: _normalizeClass(['tw-mb-[25px]']),
          title: 
          _unref(getComponentUiText)(
            'app-component-wizards-setup-wizard-more-detail-web-facing-title-1',
          )
        ,
          answer: item.value.isStatus,
          required: true,
          "text-left": 
          _unref(getComponentUiText)('app-dashboard-current-scan-type-web-service-1')
        ,
          disabled: true,
          "not-yes-no": item.value.id ? true : false,
          "mesage-error": mesageError.value,
          "text-right": 
          _unref(getComponentUiText)('app-setup-webfacing-aplication-native-app-1')
        ,
          onOnUpdate: checkYesNo
        }, null, 8, ["title", "answer", "text-left", "not-yes-no", "mesage-error", "text-right"]),
        _createElementVNode("div", _hoisted_4, [
          (item.value.isStatus === 1)
            ? (_openBlock(), _createBlock(WizardInputQuestion, {
                key: 0,
                modelValue: item.value.url,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.url) = $event)),
                validation: _unref(v$).url,
                type: 'text',
                "is-api-error": statusInPageClone.value && item.value.id && statusInPageClone.value.url,
                title: 
            _unref(getComponentUiText)(
              'app-component-wizards-setup-wizard-more-detail-web-facing-title-2',
            )
          ,
                required: true,
                placeholder: 
            _unref(getComponentUiText)(
              'app-component-wizards-setup-wizard-more-detail-web-facing-title-2',
            )
          ,
                "class-title": 'tw-text-[14px] !tw-leading-[100%]',
                "onUpdate:valueTeamPage": _cache[4] || (_cache[4] = 
            () => {
              !item.value.id && (item.value.isCallAPI = false);
              statusInPageClone.value &&
                statusInPageClone.value.url &&
                delete statusInPageClone.value.url;
              statusInPageClone.value &&
                (delete statusInPageClone.value.isDelete,
                delete statusInPageClone.value.serviceTypeId);
              if (
                statusInPageClone.value &&
                Object.keys(statusInPageClone.value).length === 1 &&
                statusInPageClone.value.hasOwnProperty('id')
              ) {
                delete statusInPageClone.value.id;
              }
              updateStore(item.value);
            }
          )
              }, null, 8, ["modelValue", "validation", "is-api-error", "title", "placeholder"]))
            : _createCommentVNode("", true)
        ]),
        (item.value.isStatus === 0 || item.value.isStatus === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(WizardMultiLevelMultiSelectQuestion, {
                modelValue: item.value.typeId,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((item.value.typeId) = $event)),
                  _cache[6] || (_cache[6] = 
            () => {
              !item.value.id && (item.value.isCallAPI = false);
              statusInPageClone.value &&
                statusInPageClone.value.typeId &&
                delete statusInPageClone.value.typeId;
              statusInPageClone.value &&
                (delete statusInPageClone.value.isDelete,
                delete statusInPageClone.value.serviceTypeId);
              if (
                statusInPageClone.value &&
                Object.keys(statusInPageClone.value).length === 1 &&
                statusInPageClone.value.hasOwnProperty('id')
              ) {
                delete statusInPageClone.value.id;
              }
              updateValue(item.value.typeId, item.value);
            }
          )
                ],
                title: 
            item.value.isStatus === 1
              ? _unref(getComponentUiText)('app-setting-setup-webfacing-service-type-1')
              : item.value.isStatus === 0
                ? _unref(getComponentUiText)(
                    'app-setting-setup-webfacing-aplication-type-1',
                  )
                : ''
          ,
                placeholder: 
            _unref(getComponentUiText)(
              'app-wizards-setup-wizard-more-detail-select-text-1',
            )
          ,
                "not-optional": 
            item.value.isStatus === 1 ? false : item.value.isStatus === 0 ? true : false
          ,
                "is-api-error": 
            statusInPageClone.value && item.value.id && statusInPageClone.value.typeId
          ,
                validation: _unref(v$).typeId,
                type: _unref(DROPDOWN_TYPE).SINGLE,
                "dropdown-data": 
            item.value.isStatus === 1
              ? dropdownDataValue.value[0].childData
              : dropdownDataValue.value[1].childData
          
              }, null, 8, ["modelValue", "title", "placeholder", "not-optional", "is-api-error", "validation", "type", "dropdown-data"])
            ]))
          : _createCommentVNode("", true),
        (isMoreDetails.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
                "app-component-wizards-setup-wizard-more-detail-title-1",
              )), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(getComponentUiText)(
                "app-component-wizards-setup-wizard-more-detail-sub-title-1",
              )), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(ToggleSwitch, {
                  "is-checked": isToggle.value,
                  color: "#2573E9",
                  "onUpdate:isChecked": changeMoreDetail
                }, null, 8, ["is-checked"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "data", "validation", "show-accordion", "page-active", "is-api-error"])
  ]))
}
}

})